/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { StatusDnssecAvailable } from "../../models/status-dnssec-available";
import { ZoneCreatePrimary } from "../../models/zone-create-primary";
import { ZoneCreateSecondary } from "../../models/zone-create-secondary";
import { ZonePrimary } from "../../models/zone-primary";
import { ZoneSecondary } from "../../models/zone-secondary";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface CreateZone$Params {
  organisation_id: string;
  check?: boolean;
  body: ZoneCreatePrimary | ZoneCreateSecondary;
}

export function createZone(
  http: HttpClient,
  rootUrl: string,
  params: CreateZone$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<(ZonePrimary | ZoneSecondary) | StatusDnssecAvailable>> {
  const rb = new RequestBuilder(rootUrl, createZone.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(ZonePrimary | ZoneSecondary) | StatusDnssecAvailable>;
    }),
  );
}

createZone.PATH = "/surfdomeinen/organisations/{organisation_id}/zones/";
